import { ENDORSEMENT_DETAILS_SENTINEL } from '@domain/schemas/endorsement-summary.schema';
import { BLOCK_KIND_NOUN, KIND_NOUN } from '@features/activity/copy';
import type { AuditEntry } from '@root/@types/audit-log';
import type { ResourceBlock } from '@root/@types/base';
import type { Team } from '@root/@types/types';

export interface SummaryContextDeps {
  blocks: ResourceBlock[];
  sections: { id: string; label: string }[];
  teams: Team[];
  isEndorsementSummaryView: boolean;
}

export interface SummaryContext {
  targetName: string | null;
  kindNoun: string;
  plainKindNoun: string;
  libraryKind: 'block' | 'clause';
  isEndorsementSummaryView: boolean;
  teamName: (id: string) => string;
  sectionLabel: (id?: string) => string | undefined;
  blockName: (id?: string | null) => string | undefined;
}

export const buildSummaryContext = (
  entry: AuditEntry,
  { blocks, sections, teams, isEndorsementSummaryView }: SummaryContextDeps,
): SummaryContext => {
  const plainKindNoun = KIND_NOUN(entry.target?.kind);
  const sectionLabel = (id?: string) =>
    id === ENDORSEMENT_DETAILS_SENTINEL ? 'Material Changes' : sections.find((s) => s.id === id)?.label;

  return {
    targetName:
      entry.target?.name ||
      blocks.find((b) => b.id === entry.target?.id)?.name ||
      sectionLabel(entry.target?.id) ||
      null,
    kindNoun: BLOCK_KIND_NOUN(entry.surface, entry.target?.kind),
    plainKindNoun,
    libraryKind: plainKindNoun === 'clause' ? 'clause' : 'block',
    isEndorsementSummaryView,
    teamName: (id) => teams.find((t) => String(t.id) === String(id))?.name ?? id,
    sectionLabel,
    blockName: (id) => blocks.find((b) => b.id === id)?.name,
  };
};
